<template>
  <div>
    <div class="mb-3 items-baseline sm:flex">
      <options :values="types" v-model="type" identifier="key"></options>
      <select
        name="recurring"
        class="form-select mt-2 mb-3 cursor-pointer border-0 p-0 pr-8 text-sm text-gray-500 sm:m-0 sm:ml-4"
        v-model="recurring"
        v-if="!hideRecurrence"
      >
        <option value="none" v-text="this.$t('activity.recurring.not_recurring')"></option>
        <option value="weekly" v-text="this.$t('activity.recurring.weekly')"></option>
        <option value="biweekly" v-text="this.$t('activity.recurring.biweekly')"></option>
        <option value="monthly" v-text="this.$t('activity.recurring.monthly')"></option>
        <option value="yearly" v-text="this.$t('activity.recurring.yearly')"></option>
      </select>
    </div>

    <div class="items-top md:flex">
      <div>
        <div class="flex flex-col items-start sm:flex-row sm:items-center" v-if="type">
          <div class="relative flex w-full items-center sm:w-auto">
            <span class="far fa-calendar-alt absolute left-0 ml-4 text-base"></span>
            <date-picker
              name="start_date"
              v-model="startDate"
              class="form-input w-full pl-10 sm:w-64"
              required
            ></date-picker>
          </div>

          <span
            class="my-1 sm:my-0 sm:mx-2"
            v-if="typeIn(['multiple'])"
            v-text="this.$t('activity.form.until')"
          ></span>

          <div class="relative flex w-full items-center sm:w-auto" v-if="typeIn(['multiple'])">
            <span class="far fa-calendar-alt absolute left-0 ml-4 text-base"></span>
            <date-picker
              name="end_date"
              v-model="endDate"
              class="form-input w-full pl-10 sm:w-64"
              required
            ></date-picker>
          </div>
        </div>

        <div
          class="mt-2 flex flex-col items-start sm:mt-1 sm:flex-row sm:items-center"
          v-if="typeIn(['part'])"
        >
          <div class="relative flex w-full items-center sm:w-auto">
            <span class="far fa-clock absolute left-0 ml-4"></span>
            <input
              name="start_time"
              type="time"
              v-model="startTime"
              class="form-input w-full pl-10 sm:w-auto sm:w-40"
              placeholder="--:--"
              required
            />
          </div>

          <span class="my-1 sm:my-0 sm:mx-2" v-text="this.$t('activity.form.until')"></span>

          <div class="relative flex w-full items-center sm:w-auto">
            <span class="far fa-clock absolute left-0 ml-4"></span>
            <input
              name="end_time"
              type="time"
              v-model="endTime"
              class="form-input w-full w-40 pl-10 sm:w-auto"
              placeholder="--:--"
              required
            />
          </div>
        </div>
      </div>

      <div
        class="mt-4 inline-flex flex-col items-stretch text-gray-500 md:ml-16 md:mt-0"
        v-if="additionalTimes && typeIn(['part'])"
      >
        <label class="flex items-center whitespace-nowrap">
          <span class="flex-1 text-right" v-text="this.$t('activity.form.present_time')"></span>
          <span class="relative ml-3 flex items-center" v-if="typeIn(['part'])">
            <span class="far fa-clock absolute left-0 ml-4 text-gray-500"></span>
            <input
              name="present_time"
              type="time"
              v-model="presentTime"
              class="form-input w-40 pl-10"
              placeholder="--:--"
            />
          </span>
        </label>
        <label class="mt-1 flex items-center whitespace-nowrap">
          <span class="flex-1 text-right" v-text="this.$t('activity.form.soundcheck_time')"></span>
          <span class="relative ml-3 flex items-center" v-if="typeIn(['part'])">
            <span class="far fa-clock absolute left-0 ml-4 text-gray-500"></span>
            <input
              name="soundcheck_time"
              type="time"
              v-model="soundcheckTime"
              class="form-input w-40 pl-10"
              placeholder="--:--"
            />
          </span>
        </label>
      </div>
    </div>
    <div class="mt-3 flex flex-col" v-if="dateWarnings">
      <span v-for="warning in dateWarnings" :key="warning" class="flex items-center">
        <span class="far fa-exclamation-circle mr-2 text-brand-500"></span>
        <span class="text-sm text-brand-500">{{ warning }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import Options from './Options'
export default {
  components: { Options },
  props: [
    'defaultType',
    'defaultDate',
    'datesTimes',
    'text',
    'types',
    'errors',
    'additionalTimes',
    'hideRecurrence',
  ],
  data() {
    return {
      recurring: 'none',
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      presentTime: null,
      soundcheckTime: null,
      type: null,
    }
  },
  computed: {
    dateWarnings() {
      if (this.type.key != 'part') {
        return []
      }

      let warnings = []

      if (this.endTime < this.startTime) {
        warnings.push(this.$t('activity.date_warning.end_on_next'))
      } else {
        let shiftPresent = this.presentTime && this.presentTime > this.endTime
        let shiftSoundcheck =
          this.soundcheckTime &&
          this.soundcheckTime > this.endTime &&
          (!this.presentTime || this.soundcheckTime >= this.presentTime)

        if (shiftPresent && shiftSoundcheck) {
          warnings.push(this.$t('activity.date_warning.present_and_soundcheck_on_previous'))
        } else if (shiftPresent) {
          warnings.push(this.$t('activity.date_warning.present_on_previous'))
        } else if (shiftSoundcheck) {
          warnings.push(this.$t('activity.date_warning.soundcheck_on_previous'))
        }
      }

      return warnings
    },
  },
  methods: {
    typeIn(types) {
      if (!this.type) {
        return false
      }
      return types.includes(this.type.key)
    },
    isInvalid(type) {
      return type.key === this.defaultType && this.errors
    },
    errorClass(type) {
      return { 'is-invalid': this.isInvalid(type) }
    },
    error(type) {
      return type === this.defaultType ? this.errors : null
    },
  },
  watch: {
    $data: {
      handler() {
        this.$emit('update:modelValue', this.$data)
      },
      deep: true,
    },
  },
  beforeMount() {
    this.type = this.types.find(({ key }) => {
      return key === (this.defaultType || 'whole')
    })

    if (this.defaultDate !== undefined) {
      this.startDate = this.defaultDate
      this.endDate = this.defaultDate
    }
  },
  emits: ['update:modelValue'],
}
</script>
